import { stringToColour } from "../../utility/colour";
import { connect } from "react-redux";
import { Avatar } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import { PathwayUser } from "../../redux/types/firebase";
import { selectUser } from "../../redux/selectors/firebase";

interface Username
{
    name: string
}

type UserDetails = string | Username | PathwayUser;

interface Props
{
    user?: UserDetails
    currentUser: PathwayUser
}

function getInitials(name: string): string
{
    return name.split(' ').map((n) => n[0]).join('').toUpperCase();
}

function UserAvatar({ user, currentUser }: Props)
{
    const { get } = useContext(FirebaseContext);

    const [name, setName] = useState(typeof user !== "string" && user?.name ? user.name : "");

    useEffect(() =>
    {
        if (!name)
        {
            if (typeof user === "string")
            {
                get(`users/${user}/name`).then((name) =>
                {
                    if (typeof name === "string")
                        setName(name);
                });
            }
            else if (currentUser?.name)
            {
                setName(currentUser.name);
            }
        }
    }, [user, get, currentUser, name])

    return name ? <Avatar style={{ backgroundColor: stringToColour(name) }} >
        {getInitials(name)}
    </Avatar> : null;
}

const mapStateToProps = (store: never) => ({
    currentUser: selectUser(store)
});
export default connect(mapStateToProps, {
})(UserAvatar);